import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type TAuthOutcome = "new-user" | "existing-user" | null;

type TState = {
  activeAuthType: "auth" | "forgotPassword";
  authScreen: "signup" | "login";
  isAuthReferral: boolean;
  authOutcome: TAuthOutcome;
};

type TActions = {
  setActiveAuthType: (authType: "auth" | "forgotPassword") => void;
  setAuthScreen: (screen: "signup" | "login") => void;
  setIsAuthReferral: (isAuthReferral: boolean) => void;
  setAuthOutcome: (outcome: Exclude<TAuthOutcome, null>) => void;
  clearAuthOutcome: () => void;
};

export type TAuthState = TState & TActions;

const useAuthStore = create<TAuthState>()(
  devtools((set) => ({
    activeAuthType: "auth",
    authScreen: "signup",
    isAuthReferral: false,
    authOutcome: null,
    setActiveAuthType: (activeAuthType) => set({ activeAuthType }),
    setAuthScreen: (authScreen) => set({ authScreen }),
    setIsAuthReferral: (isAuthReferral) => set({ isAuthReferral }),
    setAuthOutcome: (authOutcome) => set({ authOutcome }),
    clearAuthOutcome: () => set({ authOutcome: null }),
  })),
);

export default useAuthStore;
